import { render, staticRenderFns } from "./scLive.vue?vue&type=template&id=25270f8d&scoped=true&"
import script from "./scLive.vue?vue&type=script&lang=js&"
export * from "./scLive.vue?vue&type=script&lang=js&"
import style0 from "./scLive.vue?vue&type=style&index=0&id=25270f8d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25270f8d",
  null
  
)

export default component.exports